import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import PayRatesCard from './PayRatesCard';
import RequirementsCard from './RequirementsCard';
import ShiftsCard from './ShiftsCard';

const rootSx = { display: 'flex', flexDirection: 'column', gap: '16px' };

const ShiftDetailsTab = (props) => (
  <Box sx={rootSx}>
    <PayRatesCard {...props} />
    <ShiftsCard {...props} />
    <RequirementsCard {...props} />
  </Box>
);

ShiftDetailsTab.propTypes = {
  positionTemplate: PropTypes.shape({}).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default ShiftDetailsTab;
